module.exports = __webpack_public_path__ + "img/about-fair-003@2x.be7c48fa.jpg";